// @flow
import React, { Fragment } from 'react';

import CollapseContainer from '../Review/CollapseContainer';
import { PaymentSummarySpan as Span } from '../../../../components';

type Passenger = {
  firstName: string,
  lastName: string,
  nationality: string,
  title: string,
};

type Props = {
  passengers: Array<Passenger>,
};

const PassengerDetailSummary = ({ passengers }: Props) => (
  <CollapseContainer title="Traveler Detail" openCollapse={false}>
    {passengers.map((passenger, index) => (
      <Trekker key={passenger.firstName} {...passenger} index={index} />
    ))}
  </CollapseContainer>
);

export default PassengerDetailSummary;

const Trekker = ({
  firstName,
  lastName,
  // nationality,
  title,
  index,
}: {
  ...Passenger,
  index: number,
}) => (
  <Fragment>
    <div className="row ">
      <div className="col-12">
        <h6>Traveler {index + 1}</h6>
        <ul>
          <Span title="Full Name" value={`${firstName} ${lastName}`} />
          <Span title="Gender" value={title === 'Mr' ? 'Male' : 'Female'} />
          {/* <Span title="Nationality" value={nationality} /> */}
        </ul>
      </div>
    </div>
  </Fragment>
);



// WEBPACK FOOTER //
// ./src/screens/Trek/Self-Guided/Payment/PassengerDetailSummary.jsx